import { commonShortFieldLabels } from "./common-short-fields";

export const examAdminAiTasks = {
  pageTitle: "AI 工作台",
  pageSubtitle: "使用任务模板创建 AI 任务，直接跑真实 AI 出题、组卷和阅卷链路。",
  drawers: {
    createTitle: "新建 AI 任务",
    updateTitle: "更新 AI 任务",
    updateTitleWithId: "更新 AI 任务 #{id}",
  },
  fields: {
    taskType: "任务类型",
    sourceModule: "来源模块",
    sourceRefId: "来源对象 ID",
    modelName: "模型名称",
    promptVersion: "Prompt 版本",
    inputJson: "input_json 预览",
    taskStatus: "执行状态",
    reviewStatus: "审核状态",
    resultJson: "result_json",
  },
  actions: {
    create: "新建 AI 任务",
    runTask: "执行任务",
    applyResult: "应用结果",
    updateResult: "更新结果",
    saveUpdate: "保存更新",
  },
  messages: {
    createSuccess: "AI 任务创建成功",
    updateSuccess: "AI 任务更新成功",
    runSuccess: "AI 任务执行完成，模式：{mode}",
    applySuccess: "AI 结果已应用为 {targetType} 草稿 #{targetId}",
    appliedTarget: "已应用为 {type} #{id}",
  },
  summary: {
    total: "任务总数：{count}",
    completed: "已完成：{count}",
    pending: "待处理：{count}",
    failed: "失败：{count}",
  },
  table: {
    taskType: "任务类型",
    sourceModule: "来源模块",
    taskStatus: "执行状态",
    reviewStatus: "审核状态",
    model: "模型",
    createdAt: commonShortFieldLabels.createdAt,
    actions: "操作",
  },
  options: {
    taskTypes: {
      ingest: "AI 录题",
      generateQuestion: "AI 出题",
      generatePaper: "AI 组卷",
      scoreSubjective: "AI 阅卷",
      extractKnowledge: "知识点抽取",
    },
    taskStatusPending: "待处理",
    taskStatusRunning: "处理中",
    taskStatusCompleted: "已完成",
    taskStatusFailed: "失败",
    reviewStatusPending: "待审核",
    reviewStatusApproved: "已通过",
    reviewStatusRejected: "已驳回",
  },
  editor: {
    required: "不能为空",
    candidateQuestionTitle: "候选题 {index}",
    previewHint: "AI 工作台以模板化表单维护输入，系统自动生成 input_json。",
    sections: {
      ingestInput: "录题输入",
      generateQuestionInput: "出题输入",
      generatePaperInput: "组卷输入",
      scoreInput: "阅卷输入",
      extractKnowledgeInput: "知识点抽取输入",
    },
    fields: {
      topic: "主题",
      sourceText: "源材料",
      constraints: "约束条件",
      availableQuestions: "候选题",
      questionVersionId: "题目版本 ID（数字）",
      questionTitle: "题目标题",
      knowledgePoints: "知识点",
      candidateAnswer: "考生答案",
      fullScore: "满分",
      referencePoints: "参考得分点",
    },
    actions: {
      addConstraint: "新增约束",
      addCandidateQuestion: "新增候选题",
      addKnowledgePoint: "新增知识点",
      addReferencePoint: "新增得分点",
    },
    placeholders: {
      ingestSourceText: "输入原始材料，由 AI 整理成题目草稿",
      constraint: "例如：必须围绕 SQL 注入",
      knowledgePoint: "例如：SQL 注入",
      referencePoint: "例如：指出注入原理",
      sourceModule: "例如 question_bank / paper / review",
      modelName: "留空则使用智能中心模型连接默认配置",
      promptVersion: "v1",
    },
    templates: {
      topic: {
        sqlInjection: "SQL 注入",
      },
      ingest: {
        title: "SQL 注入案例阅读题",
        sourceText:
          "某系统在登录时将用户名和密码直接拼接进 SQL 查询语句，导致攻击者可以通过构造输入绕过认证。请根据材料整理成一道简答题。",
      },
      generateQuestion: {
        constraintSecurityFocused: "必须围绕 Web 安全中的 SQL 注入，不要生成普通 SQL 查询题",
        constraintDifferentiate: "要能够区分原理理解与防御思路",
      },
      generatePaper: {
        question1Title: "SQL 注入基础识别",
        question1KnowledgePoint: "注入识别",
        question2Title: "SQL 注入原理分析",
        question2KnowledgePoint: "注入原理",
      },
      scoreSubjective: {
        questionTitle: "请说明 SQL 注入原理及两种防御方式",
        questionStem: "请说明 SQL 注入原理及两种防御方式",
        point1: "用户输入被直接拼接进 SQL 语句",
        point2: "攻击者可改变查询逻辑",
        point3: "参数化查询",
        point4: "输入校验或最小权限",
        answer:
          "SQL 注入就是把恶意输入直接拼到 SQL 里，导致原查询逻辑被改变。防御上可以使用参数化查询，并结合输入校验。",
      },
      extractKnowledge: {
        stem: "请分析 SQL 注入、布尔盲注、时间盲注的区别，并说明常见防御策略。",
      },
    },
  },
} as const;
